import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import Header from '../../components/Header';
import Segment from '../../components/Segment';
import ConfigureThresholds from '../ConfigureThresholds';
import Toast from '../../components/Toast';

const messages = defineMessages({
  saveSuccess: {
    id: 'amnext.threshold.settings.message.success',
    defaultMessage: 'Academic Threshold settings have been successfully updated.',
  },
  mainTitle: {
    id: 'amnext.threshold.settings.title.main',
    defaultMessage: 'Academic Threshold',
  },
  firstPar: {
    id: 'amnext.threshold.settings.par.first',
    defaultMessage: 'For each audience, you can set a minimum academic threshold (GPA, SAT, or ACT) to determine which students will see your messages and be asked to connect.', // eslint-disable-line
  },
  secondPar: {
    id: 'amnext.threshold.settings.par.second',
    defaultMessage: 'When a filter is enabled, students only need to meet one academic threshold. Otherwise, students with any academic profile will be able to view your messages and be asked to connect.', // eslint-disable-line
  },
});

class ConfigureThresholdsPage extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    defaults: PropTypes.object.isRequired,
    subscriptions: PropTypes.array.isRequired,
    updateAcademicThreshold: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showSuccess: null,
      showFailure: null,
    };
  }

  handleSubmit = (defaults, subscriptions) => {
    const { intl, updateAcademicThreshold, defaults: sourceDefaults } = this.props;

    let input;

    /* istanbul ignore else */
    if (defaults) {
      let defaultVariables = defaults;
      const activeMatchSubscriptionDefaults = sourceDefaults || { version: null };

      /* istanbul ignore else */
      if (typeof activeMatchSubscriptionDefaults.version === 'number') {
        const { version } = activeMatchSubscriptionDefaults;

        defaultVariables = {
          version,
          ...defaults,
        };
      }

      input = {
        defaults: defaultVariables,
      };
    }

    /* istanbul ignore else */
    if (subscriptions) {
      if (input) {
        input = {
          ...input,
          subscriptions,
        };
      } else {
        input = { subscriptions };
      }
    }

    return updateAcademicThreshold({
      variables: {
        input,
      },
    }).then(() => {
      this.setState({
        showSuccess: intl.formatMessage(messages.saveSuccess),
      });
    }, (e) => {
      this.setState({
        showFailure: e.message,
      });
      /*
       * This rejection is to let UnsavedChangesPrompt that should not change the page
       * The value is not used for any purpose
       */
      return Promise.reject(e);
    });
  }

  handleError = (error) => {
    this.setState({
      showFailure: error.message,
    });
  }

  handleSuccessToastDismiss = () => {
    this.setState({
      showSuccess: null,
    });
  }

  handleFailureToastDismiss = () => {
    this.setState({
      showFailure: null,
    });
  }

  render() {
    const { showSuccess, showFailure } = this.state;
    const { intl, defaults, subscriptions } = this.props;

    return (
      <Segment>
        <Toast
          active={!!showSuccess}
          title=""
          kind="success"
          description={showSuccess}
          onDeactivate={this.handleSuccessToastDismiss}
        />
        <Toast
          active={!!showFailure}
          title=""
          kind="error"
          description={showFailure}
          onDeactivate={this.handleFailureToastDismiss}
        />
        <Header as="h2" size="medium">
          { intl.formatMessage(messages.mainTitle) }
        </Header>
        <p>{ intl.formatMessage(messages.firstPar) }</p>
        <p>{ intl.formatMessage(messages.secondPar) }</p>
        <ConfigureThresholds
          defaults={defaults}
          subscriptions={subscriptions}
          onSubmit={this.handleSubmit}
          onError={this.handleError}
        />
      </Segment>
    );
  }
}

export default injectIntl(ConfigureThresholdsPage);
